import { Checklist } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";
import { InsuranceGuide } from "./InsuranceGuide";
import { useHealthPlanContractContext } from "@/contexts/HealthPlanContractContext";
import { useViewContext } from "@/contexts/ViewContext";
import { currentFeatures } from "@/configs/Settings";

export function useInsuranceGuide() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();
  const { contractHealthPlan } = useHealthPlanContractContext();

  const configs: IFeatures = {
    active:
      access?.type === "professional" &&
      currentFeatures.insurance &&
      contractHealthPlan &&
      (availableRoles?.includes("manager") ||
        availableRoles?.includes("owner")),
    path: "/insuranceguide",
    icon: Checklist,
    text: "Emissão de guias",

    subitem: true,
    parent: "Planos de saúde",

    sideMenu: true,
    sideMenuIndex: 0,
    component: () => <InsuranceGuide />,
  };

  return configs;
}
